import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Avatar, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import cx from 'classnames'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    red: {
      color: '#eb0014',
    },
    green: {
      color: theme.palette.mode === 'dark' ? '#44b700' : '#228d22',
    },

    mod: {
      // marginRight: '6px',
      // fontSize: '1.0em',
      // width: 35,
      // height: 30,
      // backgroundColor: theme.palette.mode === 'dark' ? '#313131' : '#d0d0d0',
    },
  })
)

export const ModifierNumber: React.FC<{ value: number }> = ({ value }) => {
  const classes = useStyles()

  return (
    <span className={cx(classes.mod, value < 0 && classes.red, value > 0 && classes.green)}>
      {`${value > 0 ? '+' : ''}${value}`}
    </span>
  )
}
